import React, { useState } from "react";
import { apriTicket } from "./api";
import { useAuth } from "./AuthContext";
import { VERSIONE, COMMIT } from "./versione";

const CHIAVE_ULTIMA_EMAIL = "cf-ultima-email-ticket";

function emailValida(v) {
  return /\S+@\S+/.test(String(v || "").trim());
}

// Popup "📩 Apri ticket": compare al posto del vecchio messaggio morto
// "contattare assistenza" quando un file/PDF non viene riconosciuto (vedi
// Home.jsx e OrdiniMapping.jsx) — apre un ticket vero nel sistema di
// assistenza wTrendy (routes/ticket.js, API esterna documentata da
// wTrendy), con il file allegato. Manuale: compare solo il pulsante,
// l'invio richiede conferma esplicita qui dentro.
export default function ApriTicketModal({
  modulo, tipoProblema, nomeFile, azienda, clienteModa, punteggio, pdfId, fileGrezzo, onChiudi, onInviato,
}) {
  const { username } = useAuth();
  const [email, setEmail] = useState(() => {
    try { return localStorage.getItem(CHIAVE_ULTIMA_EMAIL) || ""; } catch (e) { return ""; }
  });
  const [nota, setNota] = useState("");
  const [inviando, setInviando] = useState(false);
  const [errore, setErrore] = useState("");
  const [esito, setEsito] = useState(null); // { ticketId } | null

  const etichettaProblema = tipoProblema === "pdf" ? "Layout PDF non riconosciuto" : "Template Excel non riconosciuto";
  const oggetto = `File non riconosciuto - ${modulo} - ${azienda}${clienteModa ? ` - ${clienteModa}` : ""}`;
  const descrizioneBase =
    `${etichettaProblema} in ${modulo} (azienda ${azienda}${clienteModa ? `, cliente ${clienteModa}` : ""}).\n` +
    `File: "${nomeFile || "sconosciuto"}".\n` +
    (punteggio != null
      ? `Migliore corrispondenza trovata automaticamente: ${Math.round(punteggio * 100)}% (nessun template esistente combacia abbastanza).`
      : "Nessuna corrispondenza trovata con i template/modelli esistenti.");
  const dettagliTecnici =
    `Modulo: ${modulo}\nTipo: ${tipoProblema === "pdf" ? "Modello PDF" : "Template Excel"}\nFile: ${nomeFile || "-"}\n` +
    `Azienda: ${azienda}${clienteModa ? `\nCliente: ${clienteModa}` : ""}\nUtente: ${username || "-"}\n` +
    `Versione app: ${VERSIONE} (${COMMIT})`;

  async function invia() {
    if (!emailValida(email)) {
      setErrore("Inserisci un'email valida");
      return;
    }
    setErrore("");
    setInviando(true);
    try {
      const risposta = await apriTicket({
        email_utente: email.trim(),
        oggetto,
        descrizione: descrizioneBase + (nota.trim() ? `\n\nNota dell'operatore:\n${nota.trim()}` : ""),
        dettagli_tecnici: dettagliTecnici,
        allegato: fileGrezzo || undefined,
        pdfId: tipoProblema === "pdf" ? pdfId : undefined,
      });
      try { localStorage.setItem(CHIAVE_ULTIMA_EMAIL, email.trim()); } catch (e) { /* localStorage non disponibile, poco male */ }
      setEsito({ ticketId: risposta.ticket_id });
      // Avvisa il chiamante SUBITO (non solo alla chiusura): disabilita il
      // pulsante "Apri ticket" fuori da qui finché non si carica un nuovo
      // file, per non rischiare di reinviarne uno doppio per lo stesso
      // problema riaprendo questa modale.
      if (onInviato) onInviato();
    } catch (e) {
      setErrore(e.message);
    } finally {
      setInviando(false);
    }
  }

  return (
    <div
      style={{ position: "fixed", top: 0, left: 0, right: 0, bottom: 0, backgroundColor: "rgba(15, 23, 42, 0.75)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1000, fontFamily: "Inter, sans-serif" }}
      onClick={onChiudi}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{ backgroundColor: "var(--cf-bg-card)", borderRadius: "16px", width: "560px", maxWidth: "92vw", maxHeight: "88vh", display: "flex", flexDirection: "column", overflow: "hidden", boxShadow: "0 25px 60px rgba(0,0,0,0.45)" }}
      >
        <div style={{ background: "linear-gradient(135deg, #0f172a 0%, #1e3a8a 100%)", padding: "18px 22px", display: "flex", justifyContent: "space-between", alignItems: "center", flexShrink: 0 }}>
          <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
            <span style={{ fontSize: "20px", lineHeight: 1 }}>📩</span>
            <div>
              <div style={{ fontFamily: "'Roboto Mono', Consolas, monospace", fontWeight: 700, fontSize: "15px", letterSpacing: "1px", textTransform: "uppercase", color: "#f1f5f9" }}>
                Apri ticket assistenza
              </div>
              <div style={{ fontFamily: "'Roboto Mono', Consolas, monospace", fontSize: "11px", color: "var(--cf-text-faint)", letterSpacing: "0.3px", marginTop: "3px" }}>
                {etichettaProblema}
              </div>
            </div>
          </div>
          <button className="cf-btn" onClick={onChiudi} style={{ border: "none", background: "rgba(255,255,255,0.08)", borderRadius: "6px", width: "28px", height: "28px", padding: 0, display: "flex", alignItems: "center", justifyContent: "center", fontSize: "14px", cursor: "pointer", color: "#cbd5e1", lineHeight: 1 }}>
            ✕
          </button>
        </div>

        <div style={{ padding: "24px", overflowY: "auto" }}>
          {errore && <p className="errore" style={{ marginTop: 0 }}>{errore}</p>}

          {esito ? (
            <>
              <p style={{ marginTop: 0 }}>
                ✅ Ticket aperto{esito.ticketId ? <> — numero <strong>{esito.ticketId}</strong></> : null}. wTrendy è stato
                avvisato, riceverai risposta all'email indicata.
              </p>
              <div style={{ display: "flex", justifyContent: "flex-end" }}>
                <button className="btn-primario" onClick={onChiudi}>Chiudi</button>
              </div>
            </>
          ) : (
            <>
              <p className="testo-secondario" style={{ marginTop: 0 }}>
                Verrà aperto un ticket per wTrendy con questi dati e{" "}
                {fileGrezzo || pdfId ? <>il file <strong>{nomeFile}</strong> allegato</> : "nessun allegato"}.
              </p>
              <div style={{ padding: "10px 12px", borderRadius: "8px", backgroundColor: "var(--cf-bg-subtle)", border: "1px solid var(--cf-border)", fontSize: "12px", marginBottom: "14px" }}>
                <div><strong>Oggetto:</strong> {oggetto}</div>
              </div>
              <label style={{ display: "block", marginBottom: "12px" }}>
                <span style={{ display: "block", fontSize: "12px", fontWeight: 600, marginBottom: "4px" }}>La tua email *</span>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="nome.cognome@azienda.it"
                  disabled={inviando}
                  style={{ width: "100%", boxSizing: "border-box" }}
                />
              </label>
              <label style={{ display: "block", marginBottom: "6px" }}>
                <span style={{ display: "block", fontSize: "12px", fontWeight: 600, marginBottom: "4px" }}>Nota per wTrendy (opzionale)</span>
                <textarea
                  value={nota}
                  onChange={(e) => setNota(e.target.value)}
                  placeholder="Es. questo file arriva così ogni mese da questo cliente..."
                  rows={3}
                  disabled={inviando}
                  style={{ width: "100%", boxSizing: "border-box", resize: "vertical" }}
                />
              </label>
              {inviando && (
                <p className="testo-secondario" style={{ fontSize: "12px" }}>
                  Invio in corso, può richiedere fino a 20 secondi...
                </p>
              )}
            </>
          )}
        </div>

        {!esito && (
          <div style={{ padding: "16px 24px", borderTop: "1px solid var(--cf-border)", display: "flex", justifyContent: "flex-end", gap: "8px", flexShrink: 0 }}>
            <button onClick={onChiudi} disabled={inviando}>Annulla</button>
            <button className="btn-primario" onClick={invia} disabled={inviando || !emailValida(email)}>
              {inviando ? "Invio..." : "Invia ticket"}
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
